/* eslint-disable react/jsx-boolean-value */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui';
import VisuallyHiddenLegend from '@components/shared/visually-hidden-legend';
import ControlLabel from './control-label';
import './form.scss';

const ToggleControl = ({ disabled, legend, onChange, value }) => {
  // The value is the 'true' string, thus convert to boolean with ===.
  const handleChange = useCallback(event => onChange(event.target.value === 'true'), [onChange]);

  return (
    <div styleName="control-container toggle-control">
      <FormControl component="fieldset">
        {legend && <VisuallyHiddenLegend>{legend}</VisuallyHiddenLegend>}
        <RadioGroup
          row
          name="radio-buttons-group"
          value={value}
          onChange={handleChange}
        >
          <FormControlLabel
            control={<Radio color="primary" disabled={disabled} size="small" />}
            label={<ControlLabel disabled={disabled} label="Yes" />}
            value={true}
          />
          <FormControlLabel
            control={<Radio color="primary" disabled={disabled} size="small" />}
            label={<ControlLabel disabled={disabled} label="No" />}
            value={false}
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

ToggleControl.propTypes = {
  disabled: PropTypes.bool,
  legend: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.bool
};

export default ToggleControl;
